import { useContext } from "react";
import { Material } from "../../../data/entities";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import FormType, { FieldConfigs } from "../../../shared/components/FormType";
import { PurchasingStaffDropdown } from "./PurchasingStaffDropdown";
import { SingleMaterialWrapper } from "./Styled";

interface SingleMaterialProps {
    material: Material;
    mergeMaterial: Function;
    setSubmit: Function;
    validated: boolean;
    materialFields: FieldConfigs[];
}

export const SingleMaterial = ({
                                   material,
                                   mergeMaterial,
                                   setSubmit,
                                   validated,
                                   materialFields,
                               }: SingleMaterialProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getFields = () => {
        materialFields = [
            ...materialFields.slice(0, -2),
            {
                label: "Nhân viên hậu cần mua vật tư",
                type: "custom",
                key: "purchasing_staff_id",
                required: false,
                customComponent: (
                    <PurchasingStaffDropdown purchasingStaffId={material.purchasing_staff_id}
                                             placeholder="Chọn nhân viên hậu cần" />
                ),
            },
            ...materialFields.slice(-2),
        ];
        switch (role) {
            case ROLE.DELIVERER:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
                return materialFields.map((item) => ({
                    ...item,
                    disabled: true,
                }));
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return materialFields.map((item) => ({
                    ...item,
                    disabled: item.key === "storage" || item.key === "quantity",
                }));
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
                return materialFields;
            default:
                return materialFields;
        }
    };

    return (
        <SingleMaterialWrapper>
            <FormType
                title={"Thông tin vật tư"}
                fields={getFields()}
                validated={validated}
                mergeFormData={mergeMaterial}
                setSubmit={setSubmit}
                requireData={{
                    ...material,
                }}
            />
        </SingleMaterialWrapper>
    );
};
